import type { SVGProps } from 'react';
const DawnFlagUY = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-UY_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-UY_svg__a)">
      <path
        fill="#0E4DC5"
        d="M22 2.133H10.476v2.134H22zM10.476 6.4v2.133H22V6.4zm0 4.267H0V12.8h22v-2.133zM0 16v-1.067h22V16z"
      />
      <path
        fill="#FED443"
        d="m5.239 7.457-.7 1.063-.177-1.267-1.083.65.38-1.22-1.252.106.862-.931L2.096 5.4l1.173-.457-.862-.931 1.252.106-.38-1.22 1.083.65.177-1.267.7 1.062.699-1.062.177 1.266 1.083-.649-.38 1.22 1.252-.106-.862.93 1.173.458-1.173.458.862.93-1.252-.105.38 1.22-1.083-.65-.177 1.267zm0-.02c1.104 0 2-.912 2-2.037s-.896-2.036-2-2.036-2 .912-2 2.036.895 2.037 2 2.037M6.81 5.333c0 .884-.704 1.6-1.571 1.6-.868 0-1.572-.716-1.572-1.6 0-.883.704-1.6 1.572-1.6.867 0 1.571.717 1.571 1.6"
      />
    </g>
  </svg>
);
export default DawnFlagUY;
